import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Chart from 'react-apexcharts';

import * as S from '../../styles';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/input';
import Button from '~/components/button';
import Select from '~/components/select';
import { useHistory } from 'react-router-dom';

interface IProps {
  widthGraphic?: number;
  heightGraphic?: number;
  categories: string[];
  series: {
    name: string;
    data: number[];
  }[];
  subTitle?: string;
  title?: string;
  proposalHour?: boolean;
  cadastroFrio?: boolean;
  operador?: any[];
  onClick?: (any: any) => void;
  details?: boolean;
}

const BoxOperators: React.FC<IProps> = ({
  categories,
  series,
  widthGraphic = 960,
  heightGraphic = 300,
  subTitle = '',
  title = 'Operadores',
  proposalHour = false,
  cadastroFrio = false,
  operador,
  onClick,
  details = false,
}) => {
  const [form, setForm] = useState({
    periodoInicial: moment().subtract(1, 'day').format('DD/MM/YYYY'),
    periodoFinal: moment().subtract(1, 'day').format('DD/MM/YYYY'),
    idAtendente: 'TODOS',
    tipoAlerta: 'TODOS',
  });

  const history = useHistory();

  const handleChange = (el): void => {
    onClick(el);
  };

  const handleNavigate = () => {
    history.push('/detailsColdRegistration', form);
  };

  const getFilteredData = () => {
  if (
    !Array.isArray(series) ||
    series.length === 0 ||
    !Array.isArray(categories) ||
    categories.length === 0
  ) {
    return {
      series: [
        {
          name: 'Operators',
          data: [0],
        },
      ],
      categories: ['Sem dados'],
      dataValues: [0],
    };
  }

  const originalData = Array.isArray(series[0]?.data)
    ? series[0].data
    : [];

  const originalCategories = categories;

  if (proposalHour) {
    return {
      series,
      categories,
      dataValues: originalData,
    };
  }

  const filteredData: number[] = [];
  const filteredCategories: string[] = [];

  originalData.forEach((value, index) => {
    if (value >= 1) {
      filteredData.push(value);
      filteredCategories.push(originalCategories[index]);
    }
  });

  if (filteredData.length === 0) {
    return {
      series: [
        {
          name: 'Operators',
          data: [0],
        },
      ],
      categories: ['Sem dados'],
      dataValues: [0],
    };
  }

  return {
    series: [
      {
        name: series[0]?.name ?? 'Operators',
        data: filteredData,
      },
    ],
    categories: filteredCategories,
    dataValues: filteredData,
  };
};

  const {
    series: filteredSeries,
    categories: filteredCategories,
    dataValues,
  } = getFilteredData();

  const options = {
    chart: {
      width: '100%',
      height: 300,
      type: 'bar',
    },
    plotOptions: {
      bar: {
        columnWidth: '40%',
        distributed: true,
        borderRadius: 4,
        dataLabels: {
          position: 'top',
          maxItems: 100,
        },
      },
    },
    colors: proposalHour
      ? dataValues.map((value) =>
          value <= 2 ? '#FF4D4F' : value <= 4 ? '#FFC24D' : '#09A44F',
        )
      : cadastroFrio
      ? dataValues.map((value) =>
          value <= 2 ? '#FFC24D' : value <= 3 ? '#FF4D4F' : '#77007d',
        )
      : undefined,
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: '10px',
        colors: ['#304758'],
        fontWeight: 400,
        cssClass: 'apexcharts-xaxis-label',
      },
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: filteredCategories,
      labels: {
        show: true,
        rotate: -90,
        hideOverlappingLabels: true,
        trim: false,
        minHeight: 100,
        maxHeight: 120,
        style: {
          colors: ['#304758'],
          fontSize: '12px',
          fontWeight: 400,
          cssClass: 'apexcharts-xaxis-label',
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: true,
      },
      tooltip: {
        enabled: true,
      },
      position: 'bottom',
    },
    yaxis: {
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
      labels: {
        show: true,
        formatter: (val: number) => val,
      },
    },
  } as any;

  return (
    <S.BoxDetails>
      <header>
        <h2>{title}</h2>
        {!cadastroFrio && (
          <span>
            {subTitle !== ''
              ? subTitle || !cadastroFrio
              : `Última atualização: hoje às ${moment().format(
                  'HH:mm',
                )}. Referente a data de ontem`}
          </span>
        )}
        {subTitle && proposalHour && (
          <span style={{ color: '#e4003a', fontSize: '14px' }}>
            {' '}
            (hora Manaus)
          </span>
        )}
        {cadastroFrio && (
          <ContainerFlex padding={12} row space width={90} align="center">
            <ContainerFlex row space gap="20">
              <ContainerFlex marginRight={16}>
                <Input
                  label="De"
                  placeholder="DD/MM/YYYY"
                  value={form.periodoInicial}
                  maxLength={10}
                  onChange={(e) => {
                    return setForm({
                      ...form,
                      periodoInicial: e.target.value.masked,
                    });
                  }}
                  mask={MaskTypes.DATE}
                />
              </ContainerFlex>
              <ContainerFlex marginRight={16}>
                <Input
                  label="Até"
                  placeholder="DD/MM/YYYY"
                  maxLength={10}
                  value={form.periodoFinal}
                  onChange={(e) => {
                    return setForm({
                      ...form,
                      periodoFinal: e.target.value.masked,
                    });
                  }}
                  mask={MaskTypes.DATE}
                />
              </ContainerFlex>
              <ContainerFlex marginRight={16}>
                <Select
                  label="Operador (a)"
                  options={[
                    { id: 'TODOS', value: 'Todos' },
                    { id: '6041102c1b705c0007d62e81', value: 'Web' },
                    ...operador,
                  ]}
                  value={form.idAtendente}
                  onChange={(e) => {
                    setForm({ ...form, idAtendente: e });
                  }}
                />
              </ContainerFlex>
              <ContainerFlex marginRight={16}>
                <Select
                  label="Tipo de alerta"
                  options={[
                    { id: 'TODOS', value: 'Todos' },
                    { id: 'INTERVALO', value: 'INTERVALO' },
                    {id: 'CELULAR_REPETIDO', value: 'CELULAR_REPETIDO'},
                    { id: 'UF_FORA', value: 'UF_FORA'},
                    {id: 'PENDENCIA', value: 'PENDENCIA'}
                  ]}
                  value={form.tipoAlerta}
                  onChange={(e) => {
                    setForm({ ...form, tipoAlerta: e });
                  }}
                />
              </ContainerFlex>
            </ContainerFlex>
            <ContainerFlex marginTop={24} maxWidth={14}>
              <Button onClick={() => handleChange(form)}>
                <span style={{ color: '#fff' }}>Consultar</span>
              </Button>
            </ContainerFlex>
          </ContainerFlex>
        )}
      </header>
      <S.ItemGraphic>
        <Chart
          type="bar"
          options={options}
          series={Array.isArray(filteredSeries) && filteredSeries.length > 0 ? filteredSeries : [{ name: 'Operators', data: [0] }]}
          height={heightGraphic}
          width={widthGraphic}
        />
      </S.ItemGraphic>
      {details && (
        <ContainerFlex end padding={12}>
          <Button onClick={handleNavigate}>Detalhes</Button>
        </ContainerFlex>
      )}
    </S.BoxDetails>
  );
};

export default BoxOperators;
